export default __webpack_public_path__ + "static/media/jon.69d9f915.jpg";